export default "__VITE_ASSET__BNbs08AB__"